import { render, staticRenderFns } from "./FormDocumentPublic.vue?vue&type=template&id=e763901c&scoped=true&"
import script from "./FormDocumentPublic.vue?vue&type=script&lang=js&"
export * from "./FormDocumentPublic.vue?vue&type=script&lang=js&"
import style0 from "./FormDocumentPublic.vue?vue&type=style&index=0&id=e763901c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e763901c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e763901c')) {
      api.createRecord('e763901c', component.options)
    } else {
      api.reload('e763901c', component.options)
    }
    module.hot.accept("./FormDocumentPublic.vue?vue&type=template&id=e763901c&scoped=true&", function () {
      api.rerender('e763901c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/documents/FormDocumentPublic.vue"
export default component.exports